export const environment = {
  name: 'production',
  production: true,
  APP: {
    API_URL                   : 'https://maps.propertycapsule.com/api',
    WEB_APP_URL               : 'https://maps.propertycapsule.com',
    EMBED_APP_URL             : 'https://maps.propertycapsule.com/embed-app/index.html?m=',
    DOMAIN                    : '.propertycapsule.com',
    AUTH_URL                  : 'https://maps.propertycapsule.com/auth',
    INSPECLET_ID              : '580271572',
    SEGMENT_TRACKING          : 'c9K8xWYjzoOsZ1EgHNk3qUA5vrBfPql2',
    TOURBOOK_WEB_URL          : 'https://tours.propertycapsule.com/',
    SEARCH_WEB_APP_URL        : 'https://search.propertycapsule.com',
    TOURS_WEB_APP_URL         : 'https://tours.propertycapsule.com/',
    ADMIN_WEB_APP_URL         : 'https://admin.propertycapsule.com',
    SUPPORT_EMAIL             : 'support@propertycapsule.com',
    GOOGLE_CLIENT_ID          : 'gme-propertycapsuleinc',
    JLL: {
      DOMAIN: '.jll.com',
      HOSTNAME: 'tourpointappmaps.jll.com',
      WEB_APP_URL: 'https://tourpointapp.jll.com/',
      CAPSULE_MAPS_WEB_URL: 'https://tourpointappmaps.jll.com/',
      SUPPORT_EMAIL: 'tourpoint@am.jll.com'
    }
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts